import { TableHero } from 'components/gifts-table';
import weddingRingIcon from 'assets/img/wedding-ring.svg';
import background from 'assets/img/image-plan2.png';

export default function TableHeroMock() {
  return (
    <TableHero
      readOnly
      image={background}
      typeId=""
      eventName="Boda"
      name="Jorge Facundo & Damaris Buendía"
      date={new Date()}
      eventIcon={weddingRingIcon}
    />
  );
}
